import moment from 'moment';

export const getLoginDistrictInfo=()=>{
    try{
        const _loggedInUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserDetails')||{});
        return _loggedInUserInfo;
    }catch(ex){
        return {}
    }
}
// School year is stored as the starting year (e.g. 2026 => "2026-27").
// The school year rolls over on July 1: before July 1 we are still in the
// previous year's school year (e.g. Jan 2027 is still 2026-27).
export const getCalendarSchoolYear = () => {
    const now = moment();
    // moment months are 0-indexed, so July is 6.
    return now.month() >= 6 ? now.year() : now.year() - 1;
};
// Starting school year that a given date falls in, applying the same July 1
// rollover. Returns NaN for a missing/invalid date.
const schoolYearOfDate = (date) => {
    if (!date) return NaN;
    const m = moment(date);
    if (!m.isValid()) return NaN;
    return m.month() >= 6 ? m.year() : m.year() - 1;
};
// Every starting school year that exists across the district's connected
// schools, newest first. Each school contributes the range from the school
// year of its createdOn date up to its activeSchoolYear, so a long-tenured
// school still surfaces its older years (e.g. 2024-25) while a newly-connected
// school only contributes the current year. Years are unioned across schools.
// parseInt on a missing/null activeSchoolYear yields NaN and is skipped. Falls
// back to the calendar school year when nothing valid is found.
export const getSchoolYearOptions = () => {
    const years = new Set();
    try {
        (getLoginDistrictInfo().schools || []).forEach((school) => {
            let end = parseInt(school.activeSchoolYear);
            if (Number.isNaN(end)) end = getCalendarSchoolYear();
            let start = schoolYearOfDate(school.createdOn);
            if (Number.isNaN(start) || start > end) start = end;
            for (let y = start; y <= end; y++) {
                years.add(y);
            }
        });
    } catch (ex) {
        // fall through to the calendar-year fallback below
    }
    const sorted = [...years].sort((a, b) => b - a);
    return sorted.length ? sorted : [getCalendarSchoolYear()];
};
export const dial_code = () =>{
    let symb='+1';
    const userInfo=getLoginDistrictInfo()
    try{
        return userInfo.isdCode||symb;
    }catch(ex){
    }
    return symb;
};
export const mobileNoLength = ()=> {
    let symb=10;
    try{
        const userInfo=getLoginDistrictInfo()
            return userInfo.phoneValidation||symb;
       
    }catch(ex){
    }
    return symb;
};


// WEBPACK FOOTER //
// ./src/server/utilDistrict.js